var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar fl "},[(_vm.detail.length)?_c('div',{staticStyle:{"width":"100%","height":"300px","padding":"24px","padding-bottom":"0"},attrs:{"id":_vm.id}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }